import { memo, useEffect } from "react";
import { Divider, Drawer, List, Typography, Box } from "@mui/material";
import LeftMenu from "./LeftMenu";
import { useTranslation } from "react-i18next";

import { DRAWER_WIDTH } from "base/constant/ui";
import useBreakpoint from "base/hooks/useBreakpoint";
import { sidebarState } from "base/store/sidebar";
import { useRecoilState } from "recoil";

const SideNav = () => {
  const { t } = useTranslation();
  const { isGreaterThanMd } = useBreakpoint();

  const [sidebarData, setSidebarData] = useRecoilState(sidebarState);

  useEffect(() => {
    // Always set isShowSidebar to false to reset the open state of sidebar
    setSidebarData({
      isShowSidebar: false,
    });
  }, [isGreaterThanMd]);

  return (
    <Drawer
      open={sidebarData.isShowSidebar}
      onClose={() => {
        setSidebarData({
          isShowSidebar: false,
        });
      }}
      sx={{
        width: DRAWER_WIDTH,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: DRAWER_WIDTH,
          boxSizing: "border-box",
          height: "auto",
          bottom: 0,
        },
      }}
      // This prop will handle whether the sidebar should be shown or not base on the breakpoint
      // "permanent": always show the sidebar
      // "temporary": allows the toggle operation
      variant={isGreaterThanMd ? "permanent" : "temporary"}
      anchor="left"
    >
      {/* Logo and brand*/}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 1,
        }}
      >
        <Typography variant="h5">{t("txt_dasanbooks_title")}</Typography>
      </Box>
      <Divider />

      {/* Menus */}
      <LeftMenu />
    </Drawer>
  );
};

export default memo(SideNav);
